import { getSessionStorageJSON, setSessionStorageJSON } from "../../../utils/storage";

const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
});

const state = {
    decklist: params.c || '',
    format: '',
    inStock: false,
    autofill: {
        edition: false,
        foils: false,
        price: true,
    },
    conditions: {
        NM: true,
        EX: true,
        VG: true,
        G: true,
    },
    exclude: {
        promo: false,
        ABU: false,
    },
    ...getSessionStorageJSON('deckbuilderFilters'),
};

export default {
    namespaced: true,
    state,
    getters: {
        getSearchFilters: (state) => state,
        getDecklist: (state) => state.decklist,
        getAutofillEdition: (state) => state.autofill.edition,
        getAutofillFoils: (state) => state.autofill.foils,
        getAutofillPrice: (state) => state.autofill.price,
        getFormat: (state) => state.format,
        getInStock: (state) => state.inStock,
        getExcludePromo: (state) => state.exclude.promo,
        getExcludeABU: (state) => state.exclude.ABU,
        getConditionNM: (state) => state.conditions.NM,
        getConditionEX: (state) => state.conditions.EX,
        getConditionVG: (state) => state.conditions.VG,
        getConditionG: (state) => state.conditions.G,
        getSearchQuantity: (state) => state.decklist.split(/\r?\n/).reduce((acumm, value) => {
            const trimmedValue = value.trim();
            const parsedValue = trimmedValue.replace(/^[^0-9]/g, "");  
            const realValue = !isNaN(parseInt(parsedValue)) ?
                parseInt(parsedValue) : 
                trimmedValue.replace(/ /g, '').length ? 1 : 0;
            return acumm + realValue;
        }, 0),
    },
    mutations: {
        updateDecklist: (state, payload) => {
            state.decklist = payload;
            setSessionStorageJSON('deckbuilderFilters', state);
        },
        updateAutofillEdition: (state, payload) => {
            state.autofill.edition = payload;
            setSessionStorageJSON('deckbuilderFilters', state);
        },
        updateAutofillFoils: (state, payload) => {
            state.autofill.foils = payload;
            setSessionStorageJSON('deckbuilderFilters', state);
        },
        updateAutofillPrice: (state, payload) => {
            state.autofill.price = payload;
            setSessionStorageJSON('deckbuilderFilters', state);
        },
        updateFormat: (state, payload) => {
            state.format = payload;
            setSessionStorageJSON('deckbuilderFilters', state);
        },
        updateInStock: (state, payload) => {
            state.inStock = payload;
            setSessionStorageJSON('deckbuilderFilters', state);
        },
        updateExcludePromo: (state, payload) => {
            state.exclude.promo = payload;
            setSessionStorageJSON('deckbuilderFilters', state);
        },
        updateExcludeABU: (state, payload) => {
            state.exclude.ABU = payload;
            setSessionStorageJSON('deckbuilderFilters', state);
        },
        updateConditionNM: (state, payload) => {
            state.conditions.NM = payload;
            setSessionStorageJSON('deckbuilderFilters', state);
        },
        updateConditionEX: (state, payload) => {
            state.conditions.EX = payload;
            setSessionStorageJSON('deckbuilderFilters', state);
        },
        updateConditionVG: (state, payload) => {
            state.conditions.VG = payload;
            setSessionStorageJSON('deckbuilderFilters', state);
        },
        updateConditionG: (state, payload) => {
            state.conditions.G = payload;
            setSessionStorageJSON('deckbuilderFilters', state);
        },
    },
    actions: {
        updateDecklist: ({ commit }, value) =>
            commit('updateDecklist', value),
        updateAutofillEdition: ({ commit }, value) =>
            commit('updateAutofillEdition', value),
        updateAutofillFoils: ({ commit }, value) =>
            commit('updateAutofillFoils', value),
        updateAutofillPrice: ({ commit }, value) =>
            commit('updateAutofillPrice', value),
        updateFormat: ({ commit }, value) =>
            commit('updateFormat', value),
        updateInStock: ({ commit }, value) =>
            commit('updateInStock', value),
        updateExcludePromo: ({ commit }, value) =>
            commit('updateExcludePromo', value),
        updateExcludeABU: ({ commit }, value) =>
            commit('updateExcludeABU', value),
        updateConditionNM: ({ commit }, value) =>
            commit('updateConditionNM', value),
        updateConditionEX: ({ commit }, value) =>
            commit('updateConditionEX', value),
        updateConditionVG: ({ commit }, value) =>
            commit('updateConditionVG', value),
        updateConditionG: ({ commit }, value) =>
            commit('updateConditionG', value),
    },
}